import React, { useState } from 'react';
import ButtonCustomerOrders from './ButtonCustomerOrders';
import { TbChecklist, TbUserCircle, TbStar, TbExternalLink, TbChevronRight } from 'react-icons/tb';
import { useLoginContext } from '../../Contexts/LoginContext';
import MainMenuItem from './MainMenuItem';
import Img from './Img';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useCartHook } from '../../Hooks/CartHook';
import Modal from './Modal';
import Confirm from './Confirm';
import Button from '../Form/Button';
import { HiXMark } from 'react-icons/hi2';
import ButtonLoginSSO from './ButtonLoginSSO';
import BoxContentTranslate from './BoxContentTranslate';
import { useTranslation } from 'react-i18next';
import MainMenuItemFidelity from './MainMenuItemFidelity';

const MainMenu = () => {

    const { t } = useTranslation();
    const { isAuthenticated, user } = useLoginContext();
    const { setShowMainMenu, company } = useLayoutContext();
    const navigate = useNavigate();
    const { getLinkToHome } = useStoreHook();
    const { removeLogin } = useCartHook();
    const [ showConfirmLogout, setShowConfirmLogout] = useState<boolean>(false);

    const handleClickProfile = () => {
        navigate('/perfil');
        setShowMainMenu(false);
    }

    const handleLogout = () => {
        setShowConfirmLogout(false);
        removeLogin(false);
        setShowMainMenu(false);
        navigate(getLinkToHome());
    }

    const handleNavigateToExternalLink = (external_link: string) => {
        window.open(external_link, '_blank');
    }

    const handleNavigatePage = (page: any) => {
        if (page.external_link) {
            handleNavigateToExternalLink(page.external_link) 
        } else {
            setShowMainMenu(false);
            navigate(`/page/${page.slug}`);
        }
    }

    return (
        <>
            <div className='flex flex-col justify-between h-full gap-2 relative'>

                <section className='flex flex-col divide-y h-full divide-gray-200 px-4 pt-2'>

                    {isAuthenticated && (
                        <MainMenuItem
                            onClick={handleClickProfile}
                            disabled={!isAuthenticated}
                            icon={<TbUserCircle size={23} className='zoomInIconNoDelay' />}
                            text={user?.first_name || t('menu.main.profile.label')}
                            description={t('menu.main.profile.description')}
                        />
                    )}

                    {company?.sso_active && !isAuthenticated && (
                        <ButtonLoginSSO asLink hasLinkIcon iconSize={25} className='flex gap-4 items-center p-2 py-5 cursor-pointer text-base font-semibold leading-none text-custom-primary' />
                    )}

                    {Boolean(company?.fidelity?.active) && (
                        isAuthenticated && user?.on_fidelity_program
                            ?
                                <MainMenuItemFidelity 
                                    onClick={() => {
                                        navigate('/programa-de-fidelidade');
                                        setShowMainMenu(false);
                                    }}
                                />
                            :   <MainMenuItem
                                    onClick={() => {
                                        navigate('/programa-de-fidelidade');
                                        setShowMainMenu(false);
                                    }}
                                    icon={<TbStar size={23} />}
                                    text={t('menu.main.fidelity.label')}
                                    description={t('menu.main.fidelity.description')}
                                />
                    )}

                    <ButtonCustomerOrders className={!isAuthenticated ? 'pointer-events-none' : ''}>
                        <MainMenuItem
                            icon={<TbChecklist size={25} className='zoomInIconNoDelay' />}
                            text={t('menu.main.orders.label')}
                            description={t('menu.main.orders.description')}
                            disabled={!isAuthenticated}
                        />
                    </ButtonCustomerOrders>

                    <BoxContentTranslate onBottom className='border-none' />

                    {/* PAGES */}
                    {company?.company_pages?.length > 0 && (
                        <section className='flex flex-col divide-y h-full divide-gray-200 border-none mt-4'>
                            <span className='text-gray-400 text-sm px-2'>{t('menu.main.pages')}</span>
                            <section className='flex flex-col divide-y h-full divide-gray-200 border-none'>
                                {company.company_pages.map((page: any) => (
                                    <MainMenuItem
                                        key={page.id}
                                        onClick={() => handleNavigatePage(page)}
                                        icon={page.external_link
                                            ? <TbExternalLink size={23} className='zoomInIconNoDelay' />
                                            : <TbChevronRight size={23} className='zoomInIconNoDelay' />
                                        }
                                        text={page.title}
                                    />
                                ))}
                            </section>
                        </section>
                    )}

                </section>

                {/* FOOTER */}
                <section className='flex flex-col gap-4 p-4 w-full sticky bottom-0 bg-white/65 backdrop-blur-sm'>

                    <section className='flex items-center justify-between'>
                        <div className='flex items-center gap-1 w-40'>
                            <span className='text-gray-300 text-xs -mb-1.5 text-nowrap'>V {process.env.REACT_APP_VERSION}</span>
                        </div>
                        <div className='flex gap-2 justify-center w-full -mb-1.5 grayscale'>
                            <Img src='/ditti-tagme.png' alt="Ditti by Tagme" className='max-h-12 inline opacity-75' />
                        </div>
                        <div className='flex justify-end  w-40'>
                            <Button rounded onClick={() => setShowMainMenu(false)}>
                                <div><HiXMark size={20} /></div>
                            </Button>
                        </div>
                    </section>

                </section>

            </div>

            <Modal open={showConfirmLogout} className="max-w-sm m-4" onClose={() => setShowConfirmLogout(false)}>
                <Confirm
                    title={t('login.confirm_logout_title')}
                    labelConfirm={t('login.confirm_logout_label_button')}
                    onConfirm={handleLogout}
                    onCancel={() => setShowConfirmLogout(false)}
                />
            </Modal>
        </>
    )
}

export default MainMenu;